




































import { Component, Vue, Watch, PropSync, Prop } from "vue-property-decorator";
// import { decorationData, questionData, testData, QuestionDataType } from "../../config/questionnaire";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import iwenUeditor from "@/components/iwen/ueditor.vue";
import { randomNumber } from "@/utils/commonUtil";

@Component({
  name: "logicSet",
  components: { iwenUeditor },
  filters: {},
})
export default class QuestionnaireEdit extends Vue {
  @PropSync("modalVisible", { type: Boolean }) visible!: Boolean;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;

  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  resultList?: any;

  private postForm: any = {
    resultListForm: [],
  };
  textInited = false;

  onOpen() {
    this.textInited = false;
    this.initPostForm();
    setTimeout(() => {
      // 初始化ueditor还没有实体 无法注入数据 需要滞后
      this.resultList.forEach((item: any, index: any) => {
        let ref = (this as any).$refs["ueditor" + index];
        console.log("is.resultLis", ref);
        if (ref) {
          ref[0].setContent(item.content);
        }
      });
    }, 1000);
  }
  // private rules = {
  //   title: [{ required: true, type: "string", message: "请填写标题", trigger: "blur" }],
  // };

  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get dataList() {
    return QuestionnaireEditModule.dataList;
  }
  get formLogicConfig() {
    return QuestionnaireEditModule.formLogicConfig;
  }

  deleteRule(index: number) {
    this.postForm.resultListForm.splice(index, 1);
  }
  addLogic() {
    //
    this.postForm.resultListForm.push({
      content: "",
      id: Number("1" + (randomNumber(6) + "")) * -1,
      title: "",
    });
  }

  getFormInstance() {
    return this.$refs.postForm as any;
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }

  initPostForm() {
    let postForm = {
      resultListForm: JSON.parse(JSON.stringify(this.resultList)),
    };

    this.postForm = postForm;
    this.$nextTick(() => {
      this.textInited = true;
    });
  }

  // $ handleModules

  getModulesConfigInstance() {
    return this.$refs.modulesConfig as any;
  }

  getSubmitConfigInstance() {
    return this.$refs.submitConfig as any;
  }
  async validateForSave() {
    // 保存总配置时,用来最终效验有没有失效项目
    this.clearValidate();

    console.log("logicSetvalidateForSave");
    this.initPostForm();
    return await this.validate();
  }
  async validate() {
    if (this.postForm.resultListForm.length == 0) {
      return true;
    }
    if (!this.getFormInstance()) {
      this.visible = true;
      return false;
    }
    let result = await this.getFormInstance()
      .validate()
      .catch(() => {
        return false;
      });
    console.log("itemShowLogicsValidate", result);
    if (result) {
      // QuestionnaireEditModule.SET_FORM_LOGIC_CONFIG(this.postForm);
    }
    return result;
  }
  closeDialog() {
    this.initPostForm();
    this.textInited = false;

    this.visible = false;
  }
  async handleCommit() {
    let vali = await this.validate();
    console.log("validate", vali);
    if (vali) {
      this.visible = false;
      this.$emit("success", JSON.parse(JSON.stringify(this.postForm.resultListForm)));
    }
  }
}
